module.exports = __webpack_public_path__ + "static/assets/49f5a3248030302a7f573497d20885d5.png";